var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMove = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Move",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "move_down/Round",
    transform: "translate(2, 3)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.9444, 6.2755) scale(-1, 1) translate(-3.9444, -6.2755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.55555556,6.22222222 L-1.55555556,8.55555556 L0.277777778,8.55555556 L0.277777778,6.22222222 C0.277777778,4.5033333 1.91861108,3.11111111 3.94444444,3.11111111 C5.97027781,3.11111111 7.61111111,4.5033333 7.61111111,6.22222222 L7.61111111,8.55573364 L8.52777778,9.44444444 L9.44444444,8.55573364 L9.44444444,6.22222222 C9.44444444,3.64777782 6.97861106,1.55555556 3.94444444,1.55555556 C0.91027783,1.55555556 -1.55555556,3.64777782 -1.55555556,6.22222222 Z",
    id: "Vector",
    fill: "#0A186E",
    fillRule: "nonzero",
    opacity: 0.99,
    transform: "translate(3.9444, 5.5) rotate(90) translate(-3.9444, -5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0A186E",
    x: 0.0888888889,
    y: 3.26849658e-13,
    width: 3,
    height: 1.835,
    rx: 0.9175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97094249,9.97550824 L0.688888889,7.4 M2.97094249,9.97550824 L0.688888889,12.5510165",
    id: "Vector",
    stroke: "#0A186E",
    strokeWidth: 1.5,
    opacity: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    transform: "translate(1.8299, 9.9755) rotate(-180) translate(-1.8299, -9.9755)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#0A186E",
    x: 9.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#0A186E",
    fill: "#0A186E",
    x: 9.5,
    y: 7.5,
    width: 4,
    height: 4,
    rx: 1
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Move.366e0b4829bdafaaa8d2ef46e366a9bd.svg";